import {styled} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Select from "@mui/material/Select";

export const CustomArrow = styled(KeyboardArrowDownIcon)({
    color: '#48556D',
    pointerEvents: 'none'
});

export const CustomSelect = styled(Select)({
    height: '50px',
    width: '250px',
    color: "#86BC25",
    background: 'white',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(228, 219, 233, 0.25)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(228, 219, 233, 0.25)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(228, 219, 233, 0.25)',
    },
    '.MuiSvgIcon-root ': {
        fill: "#86BC25 !important",
        marginRight: '6px',
        position: 'absolute',
        right: 0,
    }
});